import React from 'react'
import "./wikipedia.css"
import { externalWikipedia } from '../../utils/icon'



const Wikipedia = ({linkToWiki}:any) => {
  return (
    <div id='wikipedia'>
      <span>Source: </span>
      <a href={linkToWiki}>
        <p>Wikipedia</p>
        <img src={externalWikipedia} alt="External link for wikipedia content" />
      </a>
    </div>
  )
}

export default Wikipedia
